import { useUserCurrentQuery } from '../../redux/services/auth/auth.generated';
import Cookies from 'js-cookie';

const useCurrentUser = () => {
  const userToken = Cookies.get('ragya-token');
  const { data: userData, isFetching } = useUserCurrentQuery(
    {},
    { skip: !userToken }
  );

  return { user: userData?.userCurrent, isFetching };
};

export default useCurrentUser;
